module.exports = __webpack_public_path__ + "static/media/02.b9e0fa4e.jpg";